


















































































import Component from "vue-class-component";
import TextMonthChangePicker from "@/components/common/TextMonthChangePicker.vue";
import { HeaderWidthItem } from "@/types";
import { billingListDetailHeaders } from "@/components/dashboard/billingListDetailHeaders";
import { Emit, Prop, Vue, Watch } from "vue-property-decorator";

//行の状態
interface DetailStatusItem {
  detail_status?: { status: number };
}

@Component({
  components: {
    TextMonthChangePicker
  }
})
export default class AgencyBillingList extends Vue {
  @Prop({ default: "" }) private yearmonth!: string;
  @Prop({ default: "対象年月" }) private label!: string;
  @Prop({ default: "" }) private hint!: string;

  @Prop({ default: () => [] }) private tableItems!: object[];

  //選択中の行
  @Prop({ default: () => [] }) private selected!: object[];

  @Emit("update:yearmonth") private updateYearmonth(value: string) {
    return value;
  }

  @Emit("update:selected") private updateSelected(value: object[]) {
    return value;
  }

  @Emit() private search() {
    return;
  }

  @Emit() private download() {
    return;
  }

  @Watch("tableItems") watchTableItems() {
    this.onresize();
  }

  //=================================================================
  // 請求一覧（詳細）
  //=================================================================
  //項目
  private headerItems: HeaderWidthItem[] = billingListDetailHeaders;

  //登録済みの行はグレーアウト
  private itemClass(item: DetailStatusItem) {
    return item.detail_status && item.detail_status.status === 1
      ? "billing-detail-registered"
      : "";
  }

  //=================================================================
  // データテーブルのスタイル用
  //=================================================================
  private isTableScroll = true;

  //=================================================================
  // 対象年月
  //=================================================================
  private get Yearmonth() {
    return this.yearmonth;
  }
  private set Yearmonth(yearmonth: string) {
    this.updateYearmonth(yearmonth);
  }

  //=================================================================
  // マウント
  //=================================================================
  mounted() {
    // リサイズイベント登録
    window.onresize = () => {
      this.onresize();
    };
  }

  beforeDestroy() {
    window.onresize = null;
  }

  //---------------------------------------------
  //リサイズイベント
  //---------------------------------------------
  private onresize() {
    // データテーブルのスタイル切り替え
    this.isTableScroll = true;
    const dataTable = document.getElementById(
      "data-table"
    ) as HTMLElement | null;
    if (dataTable) {
      const table = dataTable.children[0].children[0] as HTMLElement | null;
      if (table) {
        if (dataTable.offsetHeight >= table.offsetHeight) {
          const root = document.getElementById("root") as HTMLElement | null;
          if (dataTable && root) {
            const dr = dataTable.getBoundingClientRect();
            const rr = root.getBoundingClientRect();
            if (rr.bottom <= dr.bottom) {
              this.isTableScroll = true;
            } else {
              this.isTableScroll = false;
            }
          }
        } else {
          // スクロール
          this.isTableScroll = true;
        }
      }
    }
  }
}
